import { setPageTitle } from '@common';
import { SystemPageLayout } from '@components';
import { useUserStoreContext } from '@store';
import React, { useEffect } from 'react';

import './AuthenticationErrorPage.scss';

function AuthenticationErrorPage(): JSX.Element {
	const { state: UserStoreState } = useUserStoreContext();

	useEffect(() => {
		setPageTitle('');
	}, []);

	let name = "—";
	let email = "—";

	if (UserStoreState && UserStoreState.user && UserStoreState.user.profile)
	{
		name = UserStoreState.user.profile.name;
		email = UserStoreState.user.profile.email;
	}
	
	const content = (<div className='auth_error'>
		<span className='important'>У вас нет прав на просмотр данной информации.</span><br/>
		<br/>
		В случае, если вы считаете, что у вас должен быть доступ — обратитесь к Администратору системы.<br/>
		<br/>
		Техническая информация:
		<ul>
			<li>Имя: {name}</li>
			<li>Email: {email}</li>
		</ul>
	</div>);

	return <SystemPageLayout content={content} />
}

export {AuthenticationErrorPage};